import React from 'react';
import { Button } from 'semantic-ui-react';
import { FilterDrawerColumn } from './FilterDrawerColumn';

export class FilterDrawer extends React.Component {
  constructor() {
    super();
    this.state = {
      whoChanged: ''
    };
  }

  interceptAndHandleFilterChange = (args) => {
    this.setState({ whoChanged: args.name });
    this.props.handleFilterChange(args);
  };

  render() {
    const { filterOptions, selectedFilters, style } = this.props;
    return (
      <div className="FilterDrawer" style={{ ...style }}>
        <div className="filter-content">
          {filterOptions &&
            filterOptions.map((filter, i) => (
              <FilterDrawerColumn
                key={i}
                title={filter.title}
                name={filter.name}
                filterOptions={filter.options}
                changeFilter={this.interceptAndHandleFilterChange}
                selectedFilters={selectedFilters}
                whoChanged={this.state.whoChanged}
              />
            ))}
        </div>
      </div>
    );
  }
}

export default FilterDrawer;
